// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"diContainer":"e3f9e14af01d94d52556","vendors-node_modules_estee_elc-buttons_src_views_Button_tsx-node_modules_estee_elc-icons_src_-5eaf07":"21e5b0797518fdb48d2c","src_exported_smartgift_SmartGift_tsx":"44191cefd6e4e946264c"}[chunkId] + ".bundle.js";
};